var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoSidebarMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 10,
    strokeDashoffset: 10,
    d: "M3 9l3 3l-3 3"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "0.2s",
    values: "10;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 16,
    strokeDashoffset: 16,
    d: "M5 5h14"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.2s",
    dur: "0.2s",
    values: "16;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 10,
    strokeDashoffset: 10,
    d: "M10 12h9"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.4s",
    dur: "0.2s",
    values: "10;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 16,
    strokeDashoffset: 16,
    d: "M5 19h14"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.6s",
    dur: "0.2s",
    values: "16;0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoSidebarMenu);
export default __webpack_public_path__ + "static/media/trvto_sidebarMenu.33a1597950bda90620b1c5b30dbe3960.svg";
export { ForwardRef as ReactComponent };